import { localStorage } from 'dibs-browser-storage';
import { trackEvent } from 'dibs-tracking';

import { hasSeenPdpTradeOnboardingModal } from '../../global/tradeOnboarding/tradeOnboardingRules';

import {
    PDP_COACHMARK_VIEWS_LOCAL_STORAGE_KEY,
    PDP_COACHMARK_TOOLTIP_DISMISSED,
    PDP_COACHMARK_MAX_VIEWS,
    PDP_ONBOARDING_TRACKING_LABEL,
    TRACKING_CATEGORY,
} from './constants';

const getPdpCoachmarkViews = () =>
    localStorage.getItem(PDP_COACHMARK_VIEWS_LOCAL_STORAGE_KEY) || [];

export const pdpCoachmarkMaxViewsExceeded = () =>
    getPdpCoachmarkViews().length > PDP_COACHMARK_MAX_VIEWS;
export const getPdpTooltipDismissed = () => !!localStorage.getItem(PDP_COACHMARK_TOOLTIP_DISMISSED);

export const canShowPdpTradeOnboardingCoachmark = (options = {}) => {
    // if showing the pdp trade onboarding modal (a notification), show the coachmark as well
    const { showingModal = false } = options;

    if (showingModal) {
        return true;
    }

    return (
        hasSeenPdpTradeOnboardingModal() &&
        !pdpCoachmarkMaxViewsExceeded() &&
        !getPdpTooltipDismissed()
    );
};

export const logCoachmarkViewForItem = itemId => {
    const coachmarkViews = getPdpCoachmarkViews();
    if (!coachmarkViews.includes(itemId)) {
        localStorage.setItem(PDP_COACHMARK_VIEWS_LOCAL_STORAGE_KEY, [...coachmarkViews, itemId]);
    }
};

export const logPdpTooltipDismissal = () => {
    localStorage.setItem(PDP_COACHMARK_TOOLTIP_DISMISSED, true);
    trackEvent({
        action: 'close button clicked',
        category: TRACKING_CATEGORY,
        label: PDP_ONBOARDING_TRACKING_LABEL,
    });
};

export const trackPdpTooltipView = () => {
    trackEvent({
        action: 'tooltip displayed',
        category: TRACKING_CATEGORY,
        label: PDP_ONBOARDING_TRACKING_LABEL,
    });
};
